import { useEffect, useRef } from "react";
import { X } from "lucide-react";

export default function BuilderMobileDrawer({

    open,

    title = "Builder Library",

    children,

    onClose

}){

    const drawerRef = useRef(null);

    useEffect(()=>{

        if(!open){

            document.body.style.overflow = "";

            return;

        }

        document.body.style.overflow = "hidden";

        function handleKeyDown(e){

            if(e.key === "Escape"){

                onClose?.();

            }

        }

        document.addEventListener(

            "keydown",

            handleKeyDown

        );

        return()=>{

            document.body.style.overflow = "";

            document.removeEventListener(

                "keydown",

                handleKeyDown

            );

        };

    },[open,onClose]);

    if(!open){

        return null;

    }

    return(

        <div

            className="builder-d-drawer-overlay"

            onClick={onClose}

        >

            <aside

                ref={drawerRef}

                className="builder-d-drawer"

                onClick={e=>

                    e.stopPropagation()

                }

            >

                <div className="builder-d-drawer-header">

                    <h2>

                        {title}

                    </h2>

                    <button

                        className="builder-d-drawer-close"

                        onClick={onClose}

                    >

                        <X size={20}/>

                    </button>

                </div>

                <div className="builder-d-drawer-body">

                    {children}

                </div>

            </aside>

            <style>{`

.builder-d-drawer-overlay{

    position:fixed;

    inset:0;

    background:rgba(15,23,42,.45);

    backdrop-filter:blur(2px);

    z-index:999999 !important;

    animation:fadeDrawer .18s ease;

}

.builder-d-drawer{

    width:320px;

    max-width:85vw;

    height:100vh;

    background:#FFF;

    display:flex;

    flex-direction:column;

    box-shadow:

        0 25px 60px rgba(15,23,42,.22);

    animation:slideDrawer .22s ease;

}

.builder-d-drawer-header{

    height:64px;

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:0 20px;

    border-bottom:1px solid #E5E7EB;

}

.builder-d-drawer-header h2{

    margin:0;

    font-size:18px;

    font-weight:700;

    color:#111827;

}

.builder-d-drawer-close{

    width:38px;

    height:38px;

    border:none;

    border-radius:10px;

    background:#F8FAFC;

    cursor:pointer;

    display:flex;

    justify-content:center;

    align-items:center;

    transition:.18s;

}

.builder-d-drawer-close:hover{

    background:#EEF2F7;

}

.builder-d-drawer-body{

    flex:1;

    overflow:auto;

}

@keyframes slideDrawer{

    from{

        transform:translateX(-100%);

    }

    to{

        transform:translateX(0);

    }

}

@keyframes fadeDrawer{

    from{

        opacity:0;

    }

    to{

        opacity:1;

    }

}

@builder-d(min-width:993px){

.builder-d-drawer-overlay{

    display:none;

}

}

`}</style>

        </div>

    );

}